import UI from "~/store/ui";

export function useUI() {
  return UI;
}
